import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "select-icon-button tw-mr-[12px]"
}
const _hoisted_2 = {
  src: "/img/elipse_selected_icon.svg",
  alt: "eclipse_icon"
}
const _hoisted_3 = {
  src: "/img/elipse_icon.svg",
  alt: "eclipse_icon"
}

import { PropType, onUpdated, ref } from "vue";
type IData = {
  id: string;
  text: string;
  selected: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'baseDropDownItem',
  props: {
  id: {
    type: String,
    required: true,
  },
  selected: {
    type: Boolean,
    default: null,
  },
  className: {
    type: String,
    default: "",
  },
  text: {
    type: String,
    required: true,
  },
  data: {
    type: Object as PropType<IData>,
    default: () => ({}),
  },
  colorTextHover: {
    type: String,
    default: "#16181b",
  },
},
  setup(__props) {

const props = __props;

_useCssVars(_ctx => ({
  "53e02797": (__props.colorTextHover)
}))

const dropdown = ref(null);

let selected = ref(props.selected);

onUpdated(() => {
  selected.value = props.selected;
});

return (_ctx: any,_cache: any) => {
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!

  return (_openBlock(), _createBlock(_component_b_dropdown_item, {
    ref_key: "dropdown",
    ref: dropdown,
    class: _normalizeClass(["base-dropdown-menu", `${props.className} tw-text-[#231F20]`]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(selected) //@ts-ignore
 ? selected.value = !_unref(selected) : selected = !_unref(selected)))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        (typeof props.selected === 'boolean')
          ? (_openBlock(), _createElementBlock("button", _hoisted_1, [
              _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
                [_vShow, _unref(selected)]
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
                [_vShow, !_unref(selected)]
              ])
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(props.text), 1)
      ])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})